'use strict';

/**
 *  Load modules
 */
import burgerMenu from './modules/burgerMenu';
import anchorLinks from './modules/anchorLinks';
import aos from './modules/aos.js';

document.addEventListener('DOMContentLoaded', () => {
    aos();
    anchorLinks();

    const header = document.querySelector('.header');

    const toggleFixedClass = () => {
        const headerHeight = header.offsetHeight;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        document.body.classList.toggle('fixed', scrollTop > headerHeight);
    };

    window.addEventListener('scroll', toggleFixedClass, { passive: true });

    toggleFixedClass();

    document.querySelectorAll('.navbar__nav a').forEach(link => {
        link.addEventListener('click', () => {
            document.body.classList.remove('nav-active');
        });
    });
});
